import React from "react";
import { Dialog } from "@headlessui/react";
import { FiAlertTriangle, FiCheck, FiHelpCircle } from "react-icons/fi";
import Modal from "../Modal";
import Button from "../Inputs/Button";

function DialogPane({
	open = false,
	variant = "success",
	title = "Title",
	description = "Description",
	onClose = () => {},
	onSubmit = () => {},
	submitLabel = "Submit",
	cancelLabel = "Cancel",
	// loading: show loader on primary button to prevent multi-submit.
	// Also support legacy `load` prop used in some older callers.
	loading = false,
	load = false,
	children,
}) {
	const variants = {
		danger: <FiAlertTriangle className="w-6 h-6 text-red-600" aria-hidden="true" />,
		success: <FiCheck className="w-6 h-6 text-green-600" aria-hidden="true" />,
		warning: <FiHelpCircle className="w-6 h-6 text-yellow-600" aria-hidden="true" />,
		info: <FiHelpCircle className="w-6 h-6 text-blue-600" aria-hidden="true" />,
	};

	const isLoading = loading || load;

	return (
		<Modal open={open ? true : false} onClose={onClose} onSubmit={onSubmit}>
			<div className="overflow-hidden bg-white rounded-lg">
				<div className="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
					<div className="sm:flex sm:items-start">
						{variant && <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto rounded-full sm:mr-4 sm:mx-0 sm:h-10 sm:w-10">{variants[variant]}</div>}
						<div className="mt-3 text-center sm:mt-0 sm:text-left">
							<Dialog.Title as="h3" className="text-base font-semibold leading-6 text-dark">
								{title}
							</Dialog.Title>
							<div className="mt-2">
								<p className="text-sm text-secondary">{description}</p>
							</div>
						</div>
					</div>
				</div>
				{children}
				<div className="flex flex-row-reverse px-4 py-3 bg-gray-50">
					<Button variant={variant} type="button" onClick={onSubmit} loading={isLoading} disabled={isLoading}>
						{submitLabel}
					</Button>
					<Button className="mr-3" variant="outlined" type="button" onClick={() => onClose()}>
						{cancelLabel}
					</Button>
				</div>
			</div>
		</Modal>
	);
}

export default DialogPane;
